import styled from 'styled-components';

export const CommingSoon = styled.span`
  font-size: ${({ theme }) => theme.fontSize.C2};
  line-height: 1.5;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.magenta700};
`;

export const PreparingMenu = styled.div<{ selected: boolean }>`
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSize.C1};
  text-align: left;
  color: ${({ theme }) => theme.colors.gray600};
  line-height: 1.5;
  padding: 10px 0 10px 20px;

  ${CommingSoon} {
    margin-left: 4px;
  }
`;

export const Divider = styled.hr`
  margin: 15px 0 15px 0;
`;

export const LNBWrapper = styled.nav`
  width: 210px;
  flex: 0 0 210px;

  & > div > ul {
    margin-bottom: 5px;
  }

  ${({ theme }) => theme.media.mobile} {
    width: auto;
  }

  ${({ theme }) => theme.media.tablet} {
    width: auto;
  }
`;
